import { NgbDateStruct, NgbDateParserFormatter, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { UtilsService } from '../utils.service';

@Component({
  selector: 'cygov-assessment-duration-calendar',
  templateUrl: './assessment-duration-calendar.component.html',
  styleUrls: ['./assessment-duration-calendar.component.scss'],
  standalone: false,
})
export class AssessmentDurationCalendarComponent implements OnInit {
  @Input() startDate: number = null;
  @Input() endDate: number = null;
  @Input() disableAll: number = 0; // 1 = disable Start Calendar, 2 = disable End Calendar , 3 disable both
  @Input() isFromReassessment: boolean = false; // 1 = disable Start Calendar, 2 = disable End Calendar , 3 disable both
  @Input() disableStartDate: boolean = false;
  @Input() disableEndDate: boolean = false;
  @Output() startDateChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() endDateChanged: EventEmitter<number> = new EventEmitter<number>();
  startDateCalendar: NgbInputDatepicker;
  endDateCalendar: NgbInputDatepicker;

  currentDateSet: NgbDateStruct | null = null;
  selectedStartDate: NgbDateStruct | null = null;
  startDateToShow: NgbDateStruct | null = null;
  selectedEndDate: NgbDateStruct | null = null;
  endDateToShow: NgbDateStruct | null = null;
  isStartDateDisabled = false;
  @Input() emptyEndDate: boolean = false;

  constructor(private parserFormatter: NgbDateParserFormatter) {}

  ngOnInit(): void {
    const currentDate = Date.now();
    this.startDate = this.startDate ? this.startDate : currentDate;
    this.endDate = this.endDate ? this.endDate : currentDate;
    if (this.endDate < currentDate) {
      const oneDayInMilliseconds = 24 * 60 * 60 * 1000; // Milliseconds in one day
      this.endDate = currentDate + oneDayInMilliseconds;
    }

    this.selectedStartDate = UtilsService.getDateInNgbDateStructFormat(new Date(this.startDate));
    this.selectedEndDate = UtilsService.getDateInNgbDateStructFormat(new Date(this.endDate));
    // this.endDateToShow = this.selectedEndDate;
    // this.startDateToShow.day = this.endDateToShow.day = 1;

    if (this.startDate > currentDate || this.isFromReassessment) {
      this.currentDateSet = UtilsService.getDateInNgbDateStructFormat(new Date(currentDate));
    }

    // this.isStartDateDisabled = this.startDate < this.currentDate ? true : false;
  }

  setCalendarRef(ref: NgbInputDatepicker, type: boolean): void {
    if (type) {
      this.startDateCalendar = ref;
      this.startDateCalendar.open();
      this.startDateCalendar.navigateTo(this.selectedStartDate);
    } else {
      this.endDateCalendar = ref;
      this.endDateCalendar.open();
      this.endDateCalendar.navigateTo(this.selectedEndDate);
    }
  }

  getDateinDateFormat(date: NgbDateStruct): Date {
    return new Date(date.year, date.month - 1, date.day);
  }

  changeDate(date, key: string): void {
    if (key === 'startDate') {
      this.selectedStartDate = date;
      date = this.parserFormatter.format(date);
      this.startDate = new Date(date).getTime();
      // innitializing end date calendar if start date is ahead of selected end date.
      if (this.startDate > this.endDate) {
        this.selectedEndDate = this.selectedStartDate;
      }

      this.startDateChanged.emit(this.startDate);

      setTimeout(() => {
        this.endDateCalendar.close();
        this.endDateCalendar.open();
        this.endDateCalendar.navigateTo(this.selectedEndDate);
      }, 50);
    } else {
      this.selectedEndDate = date;
      date = this.parserFormatter.format(date);
      this.endDate = new Date(date).getTime();
      this.emptyEndDate = !this.emptyEndDate;
      this.startDateChanged.emit(this.startDate);
      this.endDateChanged.emit(this.endDate);
      const currentDate = Date.now();
      this.currentDateSet = UtilsService.getDateInNgbDateStructFormat(new Date(currentDate));
      this.selectedEndDate = UtilsService.getDateInNgbDateStructFormat(new Date(this.endDate));
    }
  }

  calendarNavigateTrigger(event, date: NgbDateStruct): void {
    date.month = event.next.month;
    date.year = event.next.year;
  }
}
